import React, { useEffect, useState } from "react";
import {
  TextField,
  MenuItem,
  Button,
  Typography,
  Grid,
  IconButton,
  Box,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import axios from 'axios';
import { CONFIG } from '../config'
import Card from "@mui/material/Card";
import CardContent from '@mui/material/CardContent';
import { styled } from '@mui/material/styles';


const RiskRegisterFormForRisk = ({ setRegisterFormData, hierarchyData, riskData, selectedHie, editSectionId, selectedRiskEvaluateTitle, allEntityData, registerDetailId, allRegister, riskRegisterFormClose, handleCloseRisk, getAllRegister, globalCentreId, globalUserId , selectedRegisteredId, selectedRiskHierarchyIdForRisk, setOpenRiskRegisterFormForRisk,registerName}) => {


  const selectedRiskHierarchy = hierarchyData.find((item) => item.id === selectedRiskHierarchyIdForRisk);
  const selectedRegisterIdd = registerDetailId ? registerDetailId : selectedRegisteredId;
  const selectedRegister = allRegister.find((item) => item.id === selectedRegisterIdd);

  const generateSixDigitCode = () => {
    return Math.floor(100000 + Math.random() * 900000).toString();
  };

  const formatDate = (date) => {
    if (!date) return "";
    const [year, month, day] = date.split("-");
    return `${year}-${month}-${day}`;
  };

  const uniqueEntityNames = Array.from(
    new Set(allEntityData.map((data) => data.entityName))
  ).filter((name) => name !== "superadmin");


  
  const [formData, setFormData] = useState({
    riskReference: riskData.riskAdditionalData != null && riskData.riskAdditionalData.generalInformation != null?riskData.riskAdditionalData.generalInformation.riskReference:selectedRiskHierarchy.riskHierarchy.key + "-" + generateSixDigitCode(),
    riskCategory:  riskData.riskAdditionalData != null && riskData.riskAdditionalData.generalInformation != null?riskData.riskAdditionalData.generalInformation.riskCategory:riskData.name,
    objectivesAffected: riskData.riskAdditionalData != null && riskData.riskAdditionalData.generalInformation != null?riskData.riskAdditionalData.generalInformation.objectivesAffected:riskData.riskDescription,
    likelihood: riskData.riskAdditionalData != null && riskData.riskAdditionalData.assessment != null?riskData.riskAdditionalData.assessment.likelihood:riskData.riskLikelihood,
    impact: riskData.riskAdditionalData != null && riskData.riskAdditionalData.assessment != null?riskData.riskAdditionalData.assessment.impact:riskData.riskImpact,
    riskAppetite: riskData.riskAdditionalData != null && riskData.riskAdditionalData.assessment != null?riskData.riskAdditionalData.assessment.riskAppetite:riskData.riskAppetite,
    currentControls: riskData.riskAdditionalData != null && riskData.riskAdditionalData.currentControls != null?riskData.riskAdditionalData.currentControls.currentControls:'',
    controlEffectiveness: riskData.riskAdditionalData != null && riskData.riskAdditionalData.currentControls != null?riskData.riskAdditionalData.currentControls.controlEffectiveness:'',
    mitigation: riskData.riskAdditionalData != null && riskData.riskAdditionalData.mitigationActions != null?riskData.riskAdditionalData.mitigationActions.mitigation:riskData.mitigation,
    actionOwner: riskData.riskAdditionalData != null && riskData.riskAdditionalData.mitigationActions != null?riskData.riskAdditionalData.mitigationActions.actionOwner:'',
    targetCompletionDate: riskData.riskAdditionalData != null && riskData.riskAdditionalData.mitigationActions != null?riskData.riskAdditionalData.mitigationActions.targetCompletionDate:'',
    status: riskData.riskAdditionalData != null && riskData.riskAdditionalData.mitigationActions != null?riskData.riskAdditionalData.mitigationActions.status:'',
    reviewFrequency: riskData.riskAdditionalData != null && riskData.riskAdditionalData.monitoringAndReview != null?riskData.riskAdditionalData.monitoringAndReview.reviewFrequency:'',
    lastReviewDate: riskData.riskAdditionalData != null && riskData.riskAdditionalData.monitoringAndReview != null?riskData.riskAdditionalData.monitoringAndReview.lastReviewDate:'',
    nextReviewDate: riskData.riskAdditionalData != null && riskData.riskAdditionalData.monitoringAndReview != null?riskData.riskAdditionalData.monitoringAndReview.nextReviewDate:'',
    KRIs: riskData.riskAdditionalData != null && riskData.riskAdditionalData.monitoringAndReview != null && riskData.riskAdditionalData.monitoringAndReview.kris != null && riskData.riskAdditionalData.monitoringAndReview.kris.length > 0? riskData.riskAdditionalData.monitoringAndReview.kris.map((data) => data.keyIndicator) : [],
    supportingDocumentation: riskData.riskAdditionalData != null && riskData.riskAdditionalData.monitoringAndReview != null && riskData.riskAdditionalData.monitoringAndReview.supportingDocumentation != null && riskData.riskAdditionalData.monitoringAndReview.supportingDocumentation.length > 0? riskData.riskAdditionalData.monitoringAndReview.supportingDocumentation.map((data) => data.supportingDocument) : [],
    revisionHistory: riskData.riskAdditionalData != null && riskData.riskAdditionalData.monitoringAndReview != null && riskData.riskAdditionalData.auditTrail != null && riskData.riskAdditionalData.auditTrail.length > 0?riskData.riskAdditionalData.auditTrail : [],
  });


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });

    if (name === "likelihood" || name === "impact") {
      const likelihood = name === "likelihood" ? parseInt(value) || 0 : formData.likelihood;
      const impact = name === "impact" ? parseInt(value) || 0 : formData.impact;
      setFormData({ ...formData, riskLevel: likelihood * impact, [name]: value });
    }
  };

  const handleAddKRI = () => {
    setFormData({ ...formData, KRIs: [...formData.KRIs, ""] });
  };

  const handleRemoveKRI = (index) => {
    setFormData({
      ...formData,
      KRIs: formData.KRIs.filter((_, i) => i !== index),
    });
  };

  const handleKRIChange = (index, value) => {
    setFormData({
      ...formData,
      KRIs: formData.KRIs.map((item, i) => (i === index ? value : item)),
    });
  };

  const handleAddRevision = () => {
    setFormData({
      ...formData,
      revisionHistory: [
        ...formData.revisionHistory,
        { revisionDate: "", revisedBy: "", changesMade: "" },
      ],
    });
  };

  const handleRemoveRevision = (index) => {
    setFormData({
      ...formData,
      revisionHistory: formData.revisionHistory.filter((_, i) => i !== index),
    });
  };

  const handleRevisionChange = (index, field, value) => {
    const updatedHistory = [...formData.revisionHistory];
    updatedHistory[index][field] = value;
    setFormData({ ...formData, revisionHistory: updatedHistory });
  };


  const handleSave = async () => {
    console.log("Supporting Documentation:", formData.supportingDocumentation);
  
    try {
   
      const existingUrls = formData.supportingDocumentation.filter(item => typeof item === "string");
      const filesToUpload = formData.supportingDocumentation.filter(item => item instanceof File);
  
     
      const uploadedFileUrls = await Promise.all(
        filesToUpload.map(async (file) => {
          const uploadFormData = new FormData();
          uploadFormData.append("file", file);
          uploadFormData.append("centreId", globalCentreId);
  
          try {
            const response = await fetch(CONFIG.MAIN_URL + "/image/upload", {
              method: "POST",
              body: uploadFormData,
            });
  
            if (!response.ok) {
              throw new Error(`Failed to upload file: ${file.name}`);
            }
  
            const data = await response.json();
            return data.location;
          } catch (error) {
            console.error("Error uploading file:", error);
            return null;
          }
        })
      );
  
  
      const allSupportingDocs = [
        ...existingUrls,
        ...uploadedFileUrls.filter(Boolean),
      ];
  

      const transformedData = {
        
          generalInformation: {
            riskReference: formData.riskReference,
            riskCategory: formData.riskCategory,
            objectivesAffected: formData.objectivesAffected,
          },
          assessment: {
            likelihood: formData.likelihood,
            impact: formData.impact,
            riskLevel: formData.likelihood * formData.impact,
            riskAppetite: formData.riskAppetite,
          },
          currentControls: {
            currentControls: formData.currentControls,
            controlEffectiveness: formData.controlEffectiveness,
          },
          mitigationActions: {
            mitigation: formData.mitigation,
            actionOwner: formData.actionOwner,
            targetCompletionDate: formData.targetCompletionDate,
            status: formData.status,
          },
          monitoringAndReview: {
            reviewFrequency: formData.reviewFrequency,
            lastReviewDate: formData.lastReviewDate,
            nextReviewDate: formData.nextReviewDate,
            kris: formData.KRIs.map(kri => ({ keyIndicator: kri })),
            supportingDocumentation: allSupportingDocs.map(url => ({ supportingDocument: url })),
          },
          auditTrail: formData.revisionHistory.map(revision => ({
            revisionDate: revision.revisionDate,
            revisedBy: revision.revisedBy,
            changesMade: revision.changesMade,
          })),
        
      };
  
      setRegisterFormData(transformedData);
      console.log("Transformed Data:", transformedData);
  
   


      const updateRiskHierarchyData = (hierarchy, selectedId, data) => {
        if (!hierarchy) return;
      
        if (hierarchy.riskTypes) {
          hierarchy.riskTypes.forEach(riskType => {
            if (riskType.riskTypeId === selectedId) {
              riskType["riskAdditionalData"] = data;
            }

            if (riskType.subRisks && riskType.subRisks.length > 0) {
              updateSubRisks(riskType.subRisks, selectedId, data);
            }
          });
        }
      };
      
      const updateSubRisks = (subRisks, selectedId, data) => {
        subRisks.forEach(subRisk => {
          if (subRisk.riskTypeId === selectedId) {
            subRisk["riskAdditionalData"] = data;
          }
      
          if (subRisk.subRisks && subRisk.subRisks.length > 0) {
            updateSubRisks(subRisk.subRisks, selectedId, data);
          }
        });
      };
      
  
      selectedRegister.riskRegister.forEach(item => {
        if (item.id === editSectionId) {
          item.risks.forEach(riskItem => {
            if (riskItem.id === selectedRiskHierarchy.id) {
              updateRiskHierarchyData(
                riskItem.riskHierarchy.riskHierarchyData,
                selectedHie,
                transformedData
              );
            }
          });
        }
      });
      console.log(selectedRegister);
     
      const sendJson = JSON.stringify(selectedRegister);
      console.log(sendJson);
      
  
      await axios.post(`${CONFIG.MAIN_URL}/register/save`, sendJson, {
        headers: {
          "Content-Type": "application/json",
        },
      });
  
      alert("Register updated successfully.");
      // riskRegisterFormClose();
      // handleCloseRisk();
      // getAllRegister(globalCentreId, globalUserId);
      // setOpenRiskRegisterFormForRisk(false)
      window.location.reload();

  
      console.log("Data saved successfully!");
    } catch (error) {
      console.error("Error while saving data:", error);
      alert(`Error saving Register: ${error.message}`);
    }
  };
  
  


  const CustomTextField = styled(TextField)({
    '& .MuiInputBase-root': {
      fontSize: '9px',
      height: '25px',
      backgroundColor: 'white',
      borderRadius: '0px',
      fontWeight: 'bold',
      padding: '0px',
    },
  });

  return (
    <Box sx={{ marginTop: "-17px" }}>
      <Grid container spacing={1}>
      <Grid item xs={12}>
      <div style={{fontWeight:'bold', color:'black'}}>{riskData.riskAdditionalData != null && riskData.riskAdditionalData.generalInformation != null?riskData.riskAdditionalData.generalInformation.riskReference:selectedRiskHierarchy.riskHierarchy.key} - {registerName} <br></br><br></br>
      {riskData?.riskAdditionalData?.generalInformation?.riskCategory ? riskData?.riskAdditionalData?.generalInformation?.riskCategory : riskData.name}
      </div>
       </Grid>
 
       <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#f8d7da",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#d9534f",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>General Information</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Reference</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    //type="text"
                    id="riskReference"
                    name="riskReference"
                    value={formData.riskReference}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Category</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="text"
                    id="riskCategory"
                    name="riskCategory"
                    value={formData.riskCategory}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Objectives Affected</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    //type="text"
                    id="objectivesAffected"
                    name="objectivesAffected"
                    value={formData.objectivesAffected}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#fff3cd",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#f0ad4e",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Risk Assessment</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Likelihood</Grid>
                <Grid item xs={8}>
                  <select
                    id="likelihood"
                    name="likelihood"
                    value={formData.likelihood}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '30%' }}
                  >
                    {[1, 2, 3, 4, 5].map((val) => (
                      <>
                        {formData.likelihood === val ?
                          <option key={val} value={val} selected>{val}</option>
                          :
                          <option key={val} value={val}>{val}</option>
                        }
                      </>
                    ))}

                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Impact</Grid>
                <Grid item xs={8}>
                  <select
                    id="impact"
                    name="impact"
                    value={formData.impact}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '30%' }}
                  >
                    {[1, 2, 3, 4, 5].map((val) => (
                      <>
                        {formData.impact === val ?
                          <option key={val} value={val} selected>{val}</option>
                          :
                          <option key={val} value={val}>{val}</option>
                        }
                      </>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Appetite</Grid>
                <Grid item xs={8}>
                  <select
                    id="riskAppetite"
                    name="riskAppetite"
                    value={formData.riskAppetite}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '30%' }}
                  >
                    {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((val) => (
                      <>
                        {formData.riskAppetite === val ?
                          <option key={val} value={val} selected>{val}</option>
                          :
                          <option key={val} value={val}>{val}</option>
                        }
                      </>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Risk Level</Grid>
                <Grid item xs={8}>
                  <input
                    type="text"
                    id="riskLevel"
                    name="riskLevel"
                    value={formData.likelihood * formData.impact}
                    style={{ fontSize: '9px', height: '12px' }}
                  />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
    
        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#d4edda",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#5cb85c",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Current Controls</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Current Controls</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    //type="text"
                    id="currentControls"
                    name="currentControls"
                    value={formData.currentControls}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Control Effectiveness</Grid>
                <Grid item xs={8}>
                  <select
                    type="text"
                    id="controlEffectiveness"
                    name="controlEffectiveness"
                    value={formData.controlEffectiveness}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {formData.controlEffectiveness === 'Highly Effective' ?
                      <option value="Highly Effective" selected>Highly Effective</option>
                      :
                      <option value="Highly Effective">Highly Effective</option>
                    }
                    {formData.controlEffectiveness === 'Moderately Effective' ?
                      <option value="Moderately Effective" selected>Moderately Effective</option>
                      :
                      <option value="Moderately Effective">Moderately Effective</option>
                    }
                    {formData.controlEffectiveness === 'Needs Improvement' ?
                      <option value="Needs Improvement" selected>Needs Improvement</option>
                      :
                      <option value="Needs Improvement">Needs Improvement</option>
                    }
                  </select>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#d1ecf1",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
               <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#5bc0de",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Mitigation Actions</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Mitigation Actions</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    //type="text"
                    id="mitigation"
                    name="mitigation"
                    value={formData.mitigation}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Action Owner</Grid>
                <Grid item xs={8}>
                  <select
                    type="text"
                    id="actionOwner"
                    name="actionOwner"
                    value={formData.actionOwner}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {uniqueEntityNames.map((entityName) => (
                      <>
                        {formData.actionOwner === entityName ?
                          <option key={entityName} value={entityName} selected>{entityName}</option>
                          :
                          <option key={entityName} value={entityName}>{entityName}</option>
                        }
                      </>
                    ))}
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Target Completion Date</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="date"
                    id="targetCompletionDate"
                    name="targetCompletionDate"
                    value={formData.targetCompletionDate ? formatDate(formData.targetCompletionDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Status</Grid>
                <Grid item xs={8}>
                  <select
                    id="status"
                    name="status"
                    value={formData.status}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {formData.status === 'Not Started' ?
                      <option value="Not Started" selected>Not Started</option>
                      :
                      <option value="Not Started">Not Started</option>
                    }
                    {formData.status === 'In Progress' ?
                      <option value="In Progress" selected>In Progress</option>
                      :
                      <option value="In Progress">In Progress</option>
                    }
                    {formData.status === 'Completed' ?
                      <option value="Completed" selected>Completed</option>
                      :
                      <option value="Completed">Completed</option>
                    }
                  </select>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#e2e3e5",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >
                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#6c757d",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Monitoring & Review</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Review Frequency</Grid>
                <Grid item xs={8}>
                  <select
                    id="reviewFrequency"
                    name="reviewFrequency"
                    value={formData.reviewFrequency}
                    onChange={handleInputChange}
                    style={{ fontSize: '9px', height: '20px', width: '50%' }}
                  >
                    {formData.reviewFrequency === 'Quarterly' ?
                      <option value="Quarterly" selected>Quarterly</option>
                      :
                      <option value="Quarterly">Quarterly</option>
                    }
                    {formData.reviewFrequency === 'Semi-Annually' ?
                      <option value="Semi-Annually" selected>Semi-Annually</option>
                      :
                      <option value="Semi-Annually">Semi-Annually</option>
                    }
                    {formData.reviewFrequency === 'Annually' ?
                      <option value="Annually" selected>Annually</option>
                      :
                      <option value="Annually">Annually</option>
                    }
                  </select>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Last Review Date</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="date"
                    id="lastReviewDate"
                    name="lastReviewDate"
                    value={formData.lastReviewDate ? formatDate(formData.lastReviewDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={4} style={{ fontSize: '9px', color: '#2a3f54' }}>Next Review Date</Grid>
                <Grid item xs={8}>
                <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                <CustomTextField
                    type="date"
                    id="nextReviewDate"
                    name="nextReviewDate"
                    value={formData.nextReviewDate ? formatDate(formData.nextReviewDate.split("T")[0]) : ""}
                    onChange={handleInputChange}
                    //style={{ fontSize: '9px', height: '12px' }}
                  />
                  </Box>
                </Grid>
                <Grid item xs={12} style={{ fontSize: '9px', color: '#2a3f54' }}>KRIs (Key Risk Indicators)</Grid>
                {formData.KRIs.map((kri, index) => (
                  <>
                    <Grid item xs={11} style={{ marginTop: index > 0 ? '-10px' : '' }}>
                    <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                    <CustomTextField
                        type="text"
                        value={kri}
                        onChange={(e) => handleKRIChange(index, e.target.value)}
                        //style={{ fontSize: '9px', height: '12px' }}
                      />
                      </Box>
                    </Grid>
                    <Grid item xs={1} style={{ marginTop: index > 0 ? '-15px' : '-5px' }}>
                      <IconButton onClick={() => handleRemoveKRI(index)} color="error">
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Grid>

                  </>
                ))}
                <Grid item xs={12} style={{ marginTop: '-10px' }}>
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={handleAddKRI}

                  >
                    Add KRI
                  </Button>
                </Grid>
                <Grid item xs={12} style={{ fontSize: '9px', color: '#2a3f54' }}>Supporting Documentation</Grid>
                <Grid item xs={12}>
                  {formData.supportingDocumentation.map((doc, index) => (
                    <Stack direction="row" spacing={2} alignItems="center" key={index}>
                      <Box sx={{ flexGrow: 1 }}>
                        {typeof doc === 'string' ? (
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            <a href={doc} target="_blank" rel="noopener noreferrer">
                              {doc.split('/').pop()}
                            </a>
                          </Typography>
                        ) : (
                          <>
                            <input
                              type="file"
                              accept=".pdf,.doc,.docx,.jpg,.png"
                              onChange={(e) => {
                                const uploadedFile = e.target.files[0];
                                setFormData({
                                  ...formData,
                                  supportingDocumentation: formData.supportingDocumentation.map(
                                    (item, i) => (i === index ? uploadedFile : item)
                                  ),
                                });
                              }}
                            />
                            {doc && (
                              <Typography variant="body2" sx={{ mt: 1 }}>
                                {doc.name}
                              </Typography>
                            )}
                          </>
                        )}
                      </Box>
                      <IconButton
                        onClick={() =>
                          setFormData({
                            ...formData,
                            supportingDocumentation: formData.supportingDocumentation.filter(
                              (_, i) => i !== index
                            ),
                          })
                        }
                        color="error"
                      >
                        <RemoveCircleOutlineIcon />
                      </IconButton>
                    </Stack>
                  ))}
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={() =>
                      setFormData({
                        ...formData,
                        supportingDocumentation: [...formData.supportingDocumentation, null],
                      })
                    }
                    sx={{ mt: 2 }}
                  >
                    Add Document
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>

        <Grid item xs={12} sm={6} md={6}>
          <Card
            style={{
              width: "100%",
              backgroundColor: "#c896eb",
              borderRadius: "8px",
              border: "1px solidrgb(88, 213, 245)",
              height: '133px',
              overflowY: 'auto',
            }}>
            <CardContent style={{
              paddingLeft: '3px',
              paddingRight: '3px'

            }}>
              <Grid container spacing={0.5}
                style={{
                  marginTop: '-15px'
                }}
              >

                <Grid item xs={12} >
                  <Typography variant="h2"
                    style={{
                      backgroundColor: "#8c1dd8",
                      borderRadius: "3px",
                      textAlign: 'center',
                      fontSize: '10px',
                      color: '#ffffff',
                      padding: '4px',
                      fontWeight: 'bold',

                    }}>Audit Trail</Typography>
                </Grid>

                <Grid item xs={12}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Revision Date</TableCell>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Revised By</TableCell>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Changes Made</TableCell>
                        <TableCell style={{paddingTop: '0px', paddingBottom: '0px'}}>Actions</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {formData.revisionHistory.map((revision, index) => (
                        <TableRow key={index}>

                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                          <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                          <CustomTextField
                              type="date"
                              value={revision.revisionDate.split("T")[0]}
                              onChange={(e) => handleRevisionChange(index, "revisionDate", e.target.value)}
                              //style={{ fontSize: '9px', height: '12px', width: '100%' }}
                            />
                            </Box>
                          </TableCell>
                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                          <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                          <CustomTextField
                              //type="text"
                              value={revision.revisedBy}
                              onChange={(e) => handleRevisionChange(index, "revisedBy", e.target.value)}
                              //style={{ fontSize: '9px', height: '12px', width: '100%' }}
                            />
                            </Box>
                          </TableCell>
                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                          <Box component="form" sx={{ '& .MuiTextField-root': { m: 0, width: '100%' }, }} noValidate autoComplete="off">
                          <CustomTextField
                              type="text"
                              value={revision.changesMade}
                              onChange={(e) => handleRevisionChange(index, "changesMade", e.target.value)}
                              //style={{ fontSize: '9px', height: '12px', width: '100%' }}
                            />
                            </Box>

                          </TableCell>
                          <TableCell style={{paddingTop: '2px', paddingBottom: '2px'}}>
                            <IconButton
                              onClick={() => handleRemoveRevision(index)}
                              color="error"
                            >
                              <RemoveCircleOutlineIcon />
                            </IconButton>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  <Button
                    startIcon={<AddCircleOutlineIcon />}
                    onClick={handleAddRevision}
                    sx={{ mt: 2 }}
                  >
                    Add Revision
                  </Button>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>




        <Grid item xs={12}>
          <Stack direction="row" spacing={2}
            justifyContent="flex-end">
            <Button
              variant="contained"
              color="primary"
              onClick={handleSave}
              onActionComplete={riskRegisterFormClose}
            >
             {riskData.riskAdditionalData ? "UPDATE":"Save"} 
            </Button>
            {/* <Button
              variant="outlined"
              color="secondary"
              onClick={() => setFormData({
                riskReference: "",
                riskCategory: "",
                objectivesAffected: "",
                likelihood: 1,
                impact: 1,
                riskAppetite: 5,
                currentControls: "",
                controlEffectiveness: "",
                mitigation: "",
                actionOwner: "",
                targetCompletionDate: "",
                status: "",
                reviewFrequency: "",
                lastReviewDate: "",
                nextReviewDate: "",
                KRIs: [],
                supportingDocumentation: [],
                revisionHistory: [],
              })}
            >
              Reset
            </Button> */}
          </Stack>
        </Grid>
      </Grid>
    </Box>
  );
};

export default RiskRegisterFormForRisk;